







































































































































import _ from "lodash";
import { MaterielApi } from "../api/MaterielApi";
import { EquipementMateriel, MouvementMateriel } from "../models/Materiel";
import SortiItem from "./SortiItem.vue";
import EquipementsListModal from "./EquipementsListModal.vue";
import AlertesModal from "./AlertesModal.vue";
import MaintenanceHsModal from "./MaintenanceHsModal.vue";

export default {
    name: "DashboardPanel",
    components: {
        SortiItem,
        EquipementsListModal,
        AlertesModal,
        MaintenanceHsModal,
    },
    props: {
        refreshKey: Number,
    },
    data() {
        return {
            MaterielApi: new MaterielApi(),
            stats: null,
            loading: false,
            showEqList: false,
            eqListMode: "total",
            showAlertes: false,
            showMaintenance: false,
        };
    },
    computed: {
        total: function () {
            return this.stats ? this.stats.total : 0;
        },
        disponibles: function () {
            return this.stats ? this.stats.disponibles : 0;
        },
        sortis: function () {
            return this.stats ? this.stats.sortis : 0;
        },
        sortisPlus7j: function () {
            return this.stats ? this.stats.sortis_plus_7j : 0;
        },
        enMaintenance: function () {
            return this.stats ? this.stats.en_maintenance : 0;
        },
        horsService: function () {
            return this.stats ? this.stats.hors_service : 0;
        },
        alertes: function () {
            return this.stats && this.stats.alertes
                ? this.stats.alertes
                : { critical: [], warning: [], info: [], total: 0 };
        },
        alertesTotal: function () {
            return this.alertes.total || 0;
        },
        classeAlertes: function () {
            if (this.alertes.critical && this.alertes.critical.length > 0) {
                return "kpi-alerts-critical";
            }
            if (this.alertes.warning && this.alertes.warning.length > 0) {
                return "kpi-alerts-warning";
            }
            return "kpi-alerts-ok";
        },
        sousTitreAlertes: function () {
            if (this.alertesTotal === 0) {
                return "✓ Tout est en ordre";
            }
            return (
                (this.alertes.critical || []).length +
                " critique(s) · " +
                (this.alertes.warning || []).length +
                " avert. · " +
                (this.alertes.info || []).length +
                " info"
            );
        },
        immobilisesTotal: function () {
            return this.enMaintenance + this.horsService;
        },
        sousTitreImmobilises: function () {
            if (this.immobilisesTotal === 0) {
                return "✓ Aucun équipement immobilisé";
            }
            return (
                this.enMaintenance +
                " en maintenance · " +
                this.horsService +
                " hors service"
            );
        },
        pourcentageDisponibles: function () {
            if (!this.total) {
                return "";
            }
            return Math.round((this.disponibles / this.total) * 100) + "% du parc";
        },
        sortisItems: function () {
            let items = this.stats ? this.stats.sortis_items || [] : [];
            return _.map(items, function (item) {
                return {
                    equipement: new EquipementMateriel(item.equipement),
                    mouvement: new MouvementMateriel(item.mouvement),
                    jours: item.jours,
                };
            });
        },
    },
    created() {
        this.load();
    },
    methods: {
        load: function () {
            let self = this;
            self.loading = true;
            self.MaterielApi.getStats()
                .then(function (stats) {
                    self.stats = stats;
                    self.loading = false;
                })
                .catch(function (error) {
                    self.loading = false;
                    self.$emit("toast", {
                        message: _.get(
                            error,
                            "response.data.message",
                            "Une erreur est survenue"
                        ),
                        kind: "error",
                    });
                });
        },
        openEqList: function (mode) {
            this.eqListMode = mode;
            this.showEqList = true;
        },
    },
    watch: {
        refreshKey: function () {
            this.load();
        },
    },
};
